import * as actions from '../../redux/actions';
import * as commonActions from '../../../common/redux/actions';
import * as homeActions from '../../../home/redux/actions';
import * as myAccountActions from '../../../my-account/redux/actions';
import * as serviceActions from '../../../pb-service-list/redux/actions';

import {
	KuposDatePicker,
	KuposErrorSuccessModal,
	KuposInput,
	KuposModal,
	KuposSelectBox,
	LoginModal,
	SvgHome,
} from '../../../common';
import React, { useEffect, useRef, useState } from 'react';

import ApiUrls from '../../../../services/apiUrls';
import ChangeTicketInput from '../../ThemeTen/components/change-ticket-input';
import CommonService from '../../../../services/commonService';
import DateService from '../../../../services/dateService';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

const searchBarTabs = [
	{
		id: 1,
		title: 'COMPRA TU PASAJE',
		icon: 'BA',
		Inactive: 'ComprarInacActiveImage'
	},
	{
		id: 2,
		title: 'ANULAR PASAJE',
		icon: 'CA',
		Inactive: 'CancelTicketInactive'
	},
];

const ThemeThreeSearchBox = props => {
	const operator = props.home.operator
	const [type, setType] = useState('search');
	const [selectedTab, setSelectedTab] = useState(searchBarTabs[0]);

	useEffect(() => {
		localStorage.removeItem('isChangeTicket');
	}, []);

	let cssStyle = operator
		? `
	.tab {
		background: ${operator.color_codes.inactive_tab_color};
		color: ${operator.color_codes.secondary_text_color};
	}
	.selected-tab {
		background: ${operator.color_codes.secondary_color};
		color: ${operator.color_codes.secondary_text_color};
	}
`
		: '';

	useEffect(() => {
		// if (operator && operator.is_change_ticket) {
		// 	searchBarTabs.push({
		// 		id: 5,
		// 		title: 'Cambia',
		// 		icon: '/assets/pullmanSanAndres/san-andreas-change-ticket-icon.png',
		// 	});
		// }

		if (operator && operator.is_change_ticket) {
			searchBarTabs.push({
				active: false,
				id: 5,
				title: 'CAMBIAR PASAJE',
				icon: 'CTA',
				InActive: 'CTA',
				is_change_ticket: true,

			});
		}
		if (operator && operator.is_couponera_enabled && operator.is_couponera_enabled) {
			searchBarTabs.push({
				id: 3,
				title: 'CONFIRMAR PASAJE',
				icon: 'CCA',
				Inactive: 'CCA',

			});
			searchBarTabs.push({
				id: 4,
				title: 'CUPONERA',
				icon: 'CUA',
				Inactive: 'CUA',
			});
		}
	}, [])



	return (
		<div className="themes-theme-three-search-box">
			<style>{cssStyle}</style>
			<div className="new-container">
				<div className="home-main-selection-container">
					{(operator && operator.operator_name === "busnorte") ?
						(<div className="tabs f-14">
							{searchBarTabs.map(tab => (
								<div
									key={tab.id}
									className={`tab d-flex-c ${selectedTab.id === tab.id && operator && operator.operator_name == "busnorte" ? 'side-menu-new-bold-font less-bold-text selected-tab' : ''
										}`}
									onClick={() => setSelectedTab(tab)}
								>
									<img
										src={getIcons(selectedTab.id === tab.id ? tab.icon : tab.Inactive, operator)}
										alt=""
										style={{ width: 45, height: 28 }}
										className="bookticketicon"
									/>
									{tab.title}
								</div>
							))}
						</div>) :


						(<div className="tabs f-14">
							{searchBarTabs.map(tab => (
								<div
									key={tab.id}
									className={`tab d-flex-c ${selectedTab.id === tab.id ? 'less-bold-text selected-tab' : ''
										}`}
									onClick={() => setSelectedTab(tab)}
								>
									<img
										src={getIcons(tab.icon, operator)}
										alt=""
										style={{ width: 45, height: 28 }}
										className="bookticketicon"
									/>
									{tab.title}
								</div>
							))}
						</div>
						)

					}


					<div
						className="kupos-card  kupos-card-padding-l border-margin-block"
						style={{ borderTopRightRadius: 20, borderTopLeftRadius: 0 }}
					>
						{selectedTab.id === 1 ? (
							<SearchInput data={props} is_mot={false} />
						) : selectedTab.id === 2 || selectedTab.id === 5 ? (
							<CancelTicketInput data={props} changeTicket={selectedTab.id === 5} />
						) : selectedTab.id === 3 ? (
							<SearchInput data={props} is_mot />
						) : selectedTab.id === 4 ? (
							<CuponeraInput data={props} />
						) : null}
					</div>


				</div>
			</div>
		</div>
	);
};

const SearchInput = props => {
	const { t, home, actions, history, operator } = props.data;
	console.log('sdfsdfsfdfdf', props);
	const errorInitialState = {
		source: '',
		destination: '',
		date: '',
	};
	const [error, setError] = useState(errorInitialState);
	const destinationRef = useRef({});

	const onSourceChange = value => {
		setError({ ...error, source: null });
		actions.pbSetSourceCity(value);
		getOriginSelectedFilteredDestinations(home.uniqueCities, home.pbSourceCity);

		if (home.pbDestinationCity && value.value === home.pbDestinationCity.value) {
			onDestinationChange(null);
		}

		destinationRef.current.onMenuOpen();
		destinationRef.current.select.focus();
	};

	const onDestinationChange = value => {
		setError({ ...error, destination: null });
		actions.pbSetDestinationCity(value);
	};

	const getOriginSelectedFilteredDestinations = (rawArray, itemToRemove) => {
		if (rawArray && itemToRemove) {
			return rawArray
				.map(function (obj) {
					if (obj.label == itemToRemove.label) {
					} else {
						return obj;
					}
				})
				.filter(function (obj) {
					return typeof obj !== 'undefined';
				});
		} else if (!itemToRemove) {
			// return rawArray;
		}
	};

	const search = e => {
		e.preventDefault();
		if (props.is_mot) {
			props.data.actions.setIsMot(true);
		}
		if (!home.pbSourceCity) {
			setError({ ...error, source: 'VALIDATIONS.VALID_ORIGIN_CITY' });
			return;
		} else if (!home.pbDestinationCity) {
			setError({ ...error, destination: 'VALIDATIONS.VALID_DESTINATION_CITY' });
			return;
		} else {
			let source = home.pbSourceCity.label
				.toLowerCase()
				.replace(/-/g, '_')
				.replace(/ /g, '-')
				.replace(/_/g, '--');
			let dest = home.pbDestinationCity.label
				.toLowerCase()
				.replace(/-/g, '_')
				.replace(/ /g, '-')
				.replace(/_/g, '--');
			actions.setServiceListOnward(null);
			if (!home.returnPBDate) {
				history.push(
					`/${i18next.language}/${i18next.language == 'es' ? 'pasajes-bus' : 'bus-tickets'
					}/${source}/${dest}/${home.onwardPBDate ? home.onwardPBDate : DateService.getTodayString()
					}`,
				);
			} else {
				history.push(
					`/${i18next.language}/${i18next.language == 'es' ? 'pasajes-bus' : 'bus-tickets'
					}/${source}/${dest}/${home.onwardPBDate}/${home.returnPBDate}/1`,
				);
			}
		}
	};

	// console.log(props);

	return (
		<form onSubmit={search}>
			<div className="home-selection-input-boxes">
				<div className="home-selection-input-box font10 ">
					<span className="label font11">{t('HOME.ORIGIN')}</span>
					<KuposSelectBox
						reactSelect
						selectType="origin"
						options={home.uniqueCities ? home.uniqueCities : []}
						selectedOption={home.pbSourceCity}
						onChange={onSourceChange}
						// onInputChange={this.onInputChange}
						// placeholder={'Source'}
						icon={getIcons('Origin', operator)}
						hideArrow={true}
						error={error.source ? true : false}
						errorMessage={t(error.source)}
						placeholder={t('HOME.ORIGIN')}
						height={40}
						t={t}
					/>
				</div>

				<div className="home-selection-input-box font10">
					<span className="label font11">{t('HOME.DESTINATION')}</span>
					<KuposSelectBox
						reactSelect
						selectType="destination"
						selectRef={destinationRef}
						options={
							home.pbSourceCity
								? getOriginSelectedFilteredDestinations(home.uniqueCities, home.pbSourceCity)
								: []
						}
						selectedOption={home.pbDestinationCity}
						onChange={onDestinationChange}
						// onInputChange={this.onInputChange2}
						// placeholder={'Destination'}
						icon={getIcons('Destination', operator)}
						hideArrow={true}
						error={error.destination ? true : false}
						errorMessage={t(error.destination)}
						placeholder={t('HOME.DESTINATION')}
						height={40}
						t={t}
					/>
				</div>

				<div className="home-selection-input-box font10 datebox">
					<span className="label font11">{t('HOME.ONE_WAY')}</span>
					<KuposDatePicker
						selectedDate={home.onwardPBDate ? home.onwardPBDate : DateService.getTodayString()}
						onDateChange={date => {
							actions.setOnwardPbDate(date);
							date > home.returnPBDate ? actions.setReturnPbDate(date) : null;
						}}
						minDate={DateService.getTodayString()}
						error={error.date ? true : false}
						errorMessage={error.date}
						placeholder={t('HOME.SELECT_DATE')}
						t={t}
					/>
				</div>
				{!props.is_mot && (
					<div className="home-selection-input-box font10 datebox">
						<span className="label font11">{t('HOME.ROUND_TRIP')}</span>
						<KuposDatePicker
							selectedDate={home.returnPBDate}
							onDateChange={date => actions.setReturnPbDate(date)}
							minDate={home.onwardPBDate}
							placeholder={t('HOME.OPTIONAL_DATE')}
							// error={this.state.dateErrorReturn ? true : false}
							// errorMessage={this.state.dateErrorReturn}
							canEraseDate={true}
							t={t}
						/>
						{home.returnPBDate && (
							<img
								className="pointer"
								onClick={() => actions.setReturnPbDate('')}
								src={'/static/images/icons/cross.png'}
								alt=""
								style={{
									width: 12,
									height: 12,
									resizeMode: 'contain',
									position: 'absolute',
									right: 7,
									bottom: 18,
								}}
							/>
						)}
					</div>
				)}

				{/* <style>
          .kupos-button:hover{'{'}
          background:
          {operator && operator.color_codes && operator.color_codes.secondary_color
            ? operator.color_codes.secondary_color
            : ''}
          {'}'}
        </style> */}
				<div className="home-selection-input-box font12 datebox">
					<button
						style={{
							background:
								operator && operator.color_codes && operator.color_codes.button_color
									? operator.color_codes.button_color
									: '',
						}}
						className="kupos-button home-selection-input-button less-bold-text "
						// onClick={search}
						type="submit"
					>
						<img src={getIcons('Search', operator)} alt="" style={{ height: 30 }} />
						<span>{t('HOME.SEARCH')}</span>
					</button>
				</div>
			</div>
		</form>
	);
};

const CancelTicketInput = props => {
	const { t, history, operator } = props.data;
	const [state, setState] = useState({
		pnr: '',
		email: '',
		date: DateService.getTodayString(),
		tnc: false,
		ticketDetailError: false,
		cancelTicketErrorMessage: '',
	});

	const [pnrPopup, setPnrPopup] = useState(false);

	console.log(state);
	const search = () => {
		if (!state.pnr) {
			alert('Ingrese el número de boleto');
			return;
		} else if (!state.email) {
			alert('Ingrese correo electrónico');
			return;
		}
		// else if (!state.tnc) {
		//   alert('Aceptar terminos y condiciones');
		//   return;
		// }
		else {
			localStorage.setItem('isChangeTicket', props.changeTicket);
			const dataChangeTicket = `pnr_number=${state.pnr}&contact_info=${state.email}&travel_date=${state.date}&is_change_ticket=${props.changeTicket}&do_cancel=true`;
			const dataCancelTicket = `pnr_number=${state.pnr}&contact_info=${state.email}&travel_date=${state.date}&do_cancel=true`;
			const encryptedData = props.changeTicket
				? window.btoa(dataChangeTicket)
				: window.btoa(dataCancelTicket);
			// history.push('/modify-ticket/cancel?key=' + encryptedData);
			loadTicketDetails(encryptedData);
			// const data = `pnr_number=${state.pnr}&contact_info=${state.email}&travel_date=${state.date}`;
			// const encryptedData = window.btoa(data);
			// history.push('/modify-ticket/cancel?key=' + encryptedData);
		}
	};

	const loadTicketDetails = encryptedData => {
		console.log('propsinloadTicket', props);
		try {
			var decryptedData = window.atob(encryptedData);
			console.log('decrypted data is', decryptedData);
			// if (this.key) {
			// props.data.actions.apiCall({
			//   url: ApiUrls.ticketDetailsWithPath(decryptedData),
			//   callback: res => loadTicketDetailsResponse(res, encryptedData),
			//   type: 'home'
			// });
			let pathObj = CommonService.queryToObject(decryptedData);
			CommonService.loadEncTicketDetails(pathObj, props.data.actions.apiCall, res => {
				loadTicketDetailsResponse(res, encryptedData);
			});
			// }
		} catch (e) {
			console.log('error', e);
			// window.location.replace(window.location.origin);
			// props.actions.setTicketDetails('no data')
		}
	};

	const loadTicketDetailsResponse = (res, encryptedData) => {
		console.log('ticketres', res);
		if (res && res.body && res.body.pay_gay_info && res.body.pay_gay_info.pay_gay_type === 0) {
			setState({
				...state,
				showModal: true,
				responseMessage: "Este pasaje solo puede ser anulado en la plataforma donde fue adquirido. ",
			});
			return; // Stop further execution
		}
		if (res && res.success && res.body && res.body.pnr_number && res.body.operator_id == operator.operator_id) {
			console.log('ticketres', res, encryptedData);
			props.data.actions.setTicketDetails(res.body);
			history.push('/modify-ticket/cancel?key=' + encryptedData);
		}

		if (res && res.success && res.body && res.body.pnr_number && res.body.operator_id !== operator.operator_id) {
			setState({
				...state,
				ticketDetailError: true,
				cancelTicketErrorMessage: "No tenemos resultados con los datos compartidos. Por favor revise su información nuevamente",
			});
		}

		if (!res.success && res.body) {
			props.data.actions.setTicketDetails('no data');
			// this.setState({
			//   cancelTicketModal: true,
			//   cancelTicketTitle: 'Anulación de pasaje',
			//   cancelTicketBodyody: res.data.body.message,
			//   showDetails: false
			// })
			setState({
				...state,
				ticketDetailError: true,
				cancelTicketErrorMessage: res.body.message,
			});
		}
	};

	const handlePnrPopup = () => {
		setPnrPopup(!pnrPopup);
	};

	return (
		<div>
			<div className="home-selection-input-boxes">
				<div className="home-selection-input-box font10">
					<span className="label font11">Nº de Reserva</span>
					<KuposInput
						inputStyle={{ border: '1px solid lightgray', borderRadius: '10px' }}
						type="text"
						placeholder="Numero de reserva"
						value={state.pnr}
						onChange={pnr => setState({ ...state, pnr })}
					/>
				</div>
				<div className="home-selection-input-box font10">
					<span className="label font11">Correo electrónico</span>
					<KuposInput
						inputStyle={{ border: '1px solid lightgray', borderRadius: '10px' }}
						type="email"
						placeholder="Correo electronico"
						value={state.email}
						onChange={email => setState({ ...state, email })}
					/>
				</div>

				<div className="home-selection-input-box font10 datebox">
					<span className="label font11">Fecha de viaje</span>

					<KuposDatePicker
						// selectedDate={home.onwardPBDate ? home.onwardPBDate : DateService.getTodayString()}
						selectedDate={state.date}
						onDateChange={date => setState({ ...state, date })}
						minDate={DateService.getTodayString()}
						// error={error.date ? true : false}
						// errorMessage={error.date}
						placeholder={t('HOME.SELECT_DATE')}
						t={t}
					/>
				</div>

				<div className="home-selection-input-box font12 datebox">
					<button
						style={{
							background:
								operator && operator.color_codes && operator.color_codes.button_color
									? operator.color_codes.button_color
									: '',
						}}
						className="kupos-button home-selection-input-button less-bold-text"
						onClick={search}
					>
						<img src={getIcons('Search', operator)} alt="" />
						<span>{t('CAMBIAR')}</span>
					</button>
				</div>
			</div>
			{state.ticketDetailError && (
				<div className="pnr font10" style={{ color: 'red' }}>
					{state.cancelTicketErrorMessage ? state.cancelTicketErrorMessage : 'Error'}
				</div>
			)}
			<div className="pnr font10" onClick={handlePnrPopup}>
				¿Dónde encontrar mi número de reserva?
			</div>

			<div className="checkbox  ">
				{/* <input
          type="checkbox"
          checked={state.tnc}
          onChange={e => {
            if (e.target.checked) {
              setState({ ...state, tnc: true });
            } else {
              setState({ ...state, tnc: false });
            }
          }}
        /> */}
				{/* <a href="/terms" className="terms-link">
          Acepto términos, condiciones y políticas de cancelación.
        </a> */}

				<KuposErrorSuccessModal
					success={state.status == 200 ? true : false}
					showModal={state.showModal}
					onButtonClick={() => {
						setState({ showModal: false });
						// window.location.reload();
					}}
					bodyText={state.responseMessage}
					generalButton="OK VOLVER"

				/>

				<KuposModal
					ariaLabel="tnc-pnr-modal-outer"
					size={pnrPopup ? 'lg' : 'xl'}
					onHide={() => setPnrPopup(!pnrPopup)}
					showModal={pnrPopup}
				>
					<div className="tnc-pnr-modal">
						{pnrPopup && <img src={getIcons('pnr', operator)} alt="" />}
						<div className="close-button pointer" onClick={() => setPnrPopup(!pnrPopup)}>
							<SvgHome name="close" />
						</div>
					</div>
				</KuposModal>
			</div>
		</div>
	);
};

const CuponeraInput = props => {
	const { t, history, home, actions, operator, common } = props.data;
	const errorInitialState = {
		source: '',
		destination: '',
		date: '',
	};
	const [error, setError] = useState(errorInitialState);
	const destinationRef = useRef({});

	const onSourceChange = value => {
		setError({ ...error, source: null });
		actions.pbSetSourceCity(value);
		getOriginSelectedFilteredDestinations(home.uniqueCities, home.pbSourceCity);

		if (home.pbDestinationCity && value.value === home.pbDestinationCity.value) {
			onDestinationChange(null);
		}

		destinationRef.current.onMenuOpen();
		destinationRef.current.select.focus();
	};

	const onDestinationChange = value => {
		setError({ ...error, destination: null });
		actions.pbSetDestinationCity(value);
	};

	const getOriginSelectedFilteredDestinations = (rawArray, itemToRemove) => {
		if (rawArray && itemToRemove) {
			return rawArray
				.map(function (obj) {
					if (obj.label == itemToRemove.label) {
					} else {
						return obj;
					}
				})
				.filter(function (obj) {
					return typeof obj !== 'undefined';
				});
		} else if (!itemToRemove) {
			// return rawArray;
		}
	};
	const onSubmit = e => {
		e.preventDefault();
		if (!common.loginData) {
			actions.openCloseLoginModal(true);
		} else if (!home.pbSourceCity) {
			setError({ ...error, source: 'VALIDATIONS.VALID_ORIGIN_CITY' });
			return;
		} else if (!home.pbDestinationCity) {
			setError({ ...error, destination: 'VALIDATIONS.VALID_DESTINATION_CITY' });
			return;
		} else {
			sessionStorage.setItem('cuponeraSourceCity', JSON.stringify(home.pbSourceCity));
			sessionStorage.setItem('cuponeraDestinationCity', JSON.stringify(home.pbDestinationCity));

			history.push('/cuponera/seats');
		}
	};

	return (
		<React.Fragment>
			<form onSubmit={onSubmit}>
				<div className="home-selection-input-boxes">
					<div className="home-selection-input-box font10">
						<span className="label font11">{t('HOME.ORIGIN')}</span>
						<KuposSelectBox
							reactSelect
							selectType="origin"
							options={home.uniqueCities || []}
							selectedOption={home.pbSourceCity}
							onChange={onSourceChange}
							icon={getIcons('Origin', operator)}
							hideArrow={true}
							error={error.source ? true : false}
							errorMessage={t(error.source)}
							placeholder={t('HOME.ORIGIN')}
							height={40}
							t={t}
						/>
					</div>

					<div className="home-selection-input-box font10">
						<span className="label font11">{t('HOME.DESTINATION')}</span>
						<KuposSelectBox
							reactSelect
							selectType="destination"
							selectRef={destinationRef}
							options={
								home.pbSourceCity
									? getOriginSelectedFilteredDestinations(home.uniqueCities, home.pbSourceCity)
									: []
							}
							selectedOption={home.pbDestinationCity}
							onChange={onDestinationChange}
							icon={getIcons('Destination', operator)}
							hideArrow={true}
							error={error.destination ? true : false}
							errorMessage={t(error.destination)}
							placeholder={t('HOME.DESTINATION')}
							height={40}
							t={t}
						/>
					</div>

					<div className="home-selection-input-box font12 datebox">
						<button
							style={{
								background:
									operator && operator.color_codes && operator.color_codes.button_color
										? operator.color_codes.button_color
										: '',
							}}
							className="kupos-button home-selection-input-button less-bold-text "
							type="submit"
						>
							<img src={getIcons('Search', operator)} alt="" style={{ height: 30 }} />
							<span>{t('HOME.SEARCH')}</span>
						</button>
					</div>
				</div>
			</form>
			{home.metaData ? (
				<LoginModal
					showModal={common.showLoginModal}
					onHide={() => actions.openCloseLoginModal(false)}
					common={common}
					//   pbPaymentDetails={this.props.pbPaymentDetails}
					metaData={home.metaData}
					actions={actions}
					t={t}
					onLoginSuccess={() => actions.openCloseLoginModal(false)}
					onSignupSuccess={() => actions.openCloseLoginModal(false)}
					history={history}
					operator={home.operator}
				/>
			) : null}
		</React.Fragment>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
		home: state.home,
		common: state.common,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(
			{
				...actions,
				...serviceActions,
				...myAccountActions,
				...commonActions,
				...homeActions,
			},
			dispatch,
		),
	};
}
export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withTranslation('common')(ThemeThreeSearchBox));



// WEBPACK FOOTER //
// ./src/features/themes/ThemeThree/common/ThemeThreeSearchBox.js